/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabDepartmentItem from './lab-department-item';
import LabDepartmentItemDetail from './lab-department-item-detail';
import LabDepartmentItemUpdate from './lab-department-item-update';
import LabDepartmentItemDeleteDialog from './lab-department-item-delete-dialog';

const LabDepartmentItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabDepartmentItem />} />
    <Route path="new" element={<LabDepartmentItemUpdate />} />
    <Route path=":id">
      <Route index element={<LabDepartmentItemDetail />} />
      <Route path="edit" element={<LabDepartmentItemUpdate />} />
      <Route path="delete" element={<LabDepartmentItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabDepartmentItemRoutes;
